/** @format */

export const AuthInfoKey = 'AuthInfo';
